import { Box, Container, Stack, Typography } from '@mui/material'
import { SippLogoBlack} from '../icons'
import { SippLogoWhite } from '../icons'

export const TestStripFooter = ({
  children,
  backgroundColor = 'primary.dark',
  isGlobal = true,
}: {
  children: React.ReactNode,
  backgroundColor?: string,
  isGlobal?: boolean,
}) => {
  return (
    <Box sx={{ backgroundColor, color: 'white', pb: 5 }}>
      <Container maxWidth="md">
        <Stack alignItems="center" gap={6}>
          {children}
          <Stack alignItems="center" spacing={1}>
            {isGlobal ?  <SippLogoWhite sx={{ fontSize: '2.5rem', color: 'text.primary' }} /> : <SippLogoBlack sx={{ fontSize: '2.5rem', color: 'text.primary' }} />}
            <Stack spacing={0.5}>
              <Typography color={isGlobal ? 'text.white' : 'text.primary'} fontSize={'0.85rem'}>support@sippsafely.com</Typography>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </Box>
  )
}
